import axios, { InternalAxiosRequestConfig } from 'axios';

// override for local development in .env.development.local, e.g. REACT_APP_API_BASE=http://localhost:5000
const API_BASE = process.env.REACT_APP_API_BASE || 'https://chalet.dropmann.ch'
export const WS_URL = process.env.REACT_APP_WS_URL || 'wss://chalet.dropmann.ch/ws'

// read the token on every request - it changes on login/logout
function getToken(): string | null {
  const token = localStorage.getItem('token')
  if (!token) return null
  const cleaned = token.replace(/"/g, '')
  if (cleaned === '' || cleaned === 'null') return null
  return cleaned
}

const api = axios.create({
    //withCredentials: true,
     baseURL: `${API_BASE}/api`,
   // adding a custom language header
   headers: {
     "Custom-Language": "en",
   },
 });

api.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const token = getToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// token expired or invalid: drop it and go back to the login page
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.setItem('token', JSON.stringify(null))
      localStorage.setItem('user', JSON.stringify(null))
      if (window.location.pathname !== '/login') {
        window.location.assign('/login')
      }
    }
    return Promise.reject(error)
  }
)

export const loginapi = axios.create({
  //withCredentials: true,
  baseURL: `${API_BASE}/auth`,
 // adding a custom language header
 headers: {
   "Custom-Language": "en",
 },
});

 export default api;
